import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { getDataForEachTab } from "./features/CaseSlice";
import { getTabList } from "./features/TabNameSlice";
import DynamicTab from "./utlity/DynamicTab";
import SlideViewer from "./utlity/SlideViewer";

const AppRouter = () => {
  const { data, loading, error } = useSelector((state) => state.tab);
  const tabs = loading ? [""] : data;

  return (
    <div className="app-content">
      <Routes>
        {tabs &&
          tabs?.map((tab) => (
            <Route
              key={tab}
              path={tab}
              element={<DynamicTab />}
            />
          ))}

        {tabs &&
          tabs?.map((tab) => (
            <Route
              key={tab}
              path={`${tab}/:caseName`}
              element={<SlideViewer />}
            />
          ))}
      </Routes>
    </div>
  );
};

function AppContent() {
  const location = useLocation();
  let path = location.pathname.split("/");
  let pathName = path.length === 2 && path[1];
  const [name, setName] = useState(pathName);
  const dispatch = useDispatch();

  useEffect(() => {
    setName(pathName);
    sessionStorage.setItem("currentTab", location.pathname.slice(1));
  }, [location.pathname]);

  useEffect(() => {
    if (name) {
      dispatch(getDataForEachTab(name));
    }
  }, [dispatch, name]);

  return null;
}

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Hide header on slide viewer pages (path has 3+ segments like /home/case1)
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isSlideViewer = pathSegments.length >= 2;

  // Hide footer when hideui=1 query parameter is present
  const searchParams = new URLSearchParams(location.search);
  const hideUI = searchParams.get("hideui") === "1";

  useEffect(() => {
    dispatch(getTabList());
  }, [dispatch]);

  useEffect(() => {
    // Only redirect if at root path — preserve direct URLs with query params
    if (location.pathname === "/") {
      const savedTabName = sessionStorage.getItem("currentTab");
      if (savedTabName) {
        navigate(`/${savedTabName}`);
      } else {
        navigate("/home");
      }
    }
  }, [navigate]);

  return (
    <div className="app-wrapper">
      {!isSlideViewer && <Header />}
      <AppContent />
      <AppRouter />
      {!hideUI && <Footer />}
    </div>
  );
}

export default App;
